<template>
  <div
    v-if="result"
    class="mb-4 p-4 rounded-lg shadow-md border"
    :class="result.success ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'"
  >
    <div class="flex items-start justify-between">
      <div class="flex items-start flex-1">
        <!-- Icon -->
        <div class="flex-shrink-0">
          <CheckCircleIcon v-if="result.success" class="h-6 w-6 text-green-500" />
          <XCircleIcon v-else class="h-6 w-6 text-red-500" />
        </div>

        <!-- Content -->
        <div class="ml-3 flex-1">
          <h3
            class="text-sm font-medium"
            :class="result.success ? 'text-green-800' : 'text-red-800'"
          >
            {{ result.success ? 'Synchronisatie succesvol' : 'Synchronisatie mislukt' }}
          </h3>

          <!-- Success Stats -->
          <div v-if="result.success && hasStats" class="mt-2 text-sm text-green-700">
            <div class="flex flex-wrap gap-4">
              <div v-if="result.data?.inserted > 0" class="flex items-center gap-1">
                <PlusCircleIcon class="h-4 w-4 text-green-600" />
                <span class="font-semibold">{{ result.data.inserted }}</span>
                <span>nieuw</span>
              </div>
              <div v-if="result.data?.updated > 0" class="flex items-center gap-1">
                <ArrowPathIcon class="h-4 w-4 text-blue-600" />
                <span class="font-semibold">{{ result.data.updated }}</span>
                <span>geüpdatet</span>
              </div>
              <div v-if="result.data?.deleted > 0" class="flex items-center gap-1">
                <TrashIcon class="h-4 w-4 text-red-600" />
                <span class="font-semibold">{{ result.data.deleted }}</span>
                <span>verwijderd</span>
              </div>
            </div>
            <div v-if="result.data?.duration" class="mt-1 text-xs text-green-600">
              Voltooid in {{ formatDuration(result.data.duration) }}
            </div>
          </div>

          <!-- Error Message -->
          <p v-if="!result.success" class="mt-1 text-sm text-red-700">
            {{ result.error || 'Onbekende fout opgetreden' }}
          </p>

          <!-- Simple success message if no stats -->
          <p v-if="result.success && !hasStats" class="mt-1 text-sm text-green-700">
            {{ result.message || 'Nieuwe informatie is ingeladen' }}
          </p>
        </div>
      </div>

      <!-- Close button -->
      <button
        @click="$emit('close')"
        class="ml-4 flex-shrink-0 inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
      >
        <XMarkIcon class="h-5 w-5" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  CheckCircleIcon,
  XCircleIcon,
  XMarkIcon,
  PlusCircleIcon,
  ArrowPathIcon,
  TrashIcon
} from '@heroicons/vue/24/outline'

const props = defineProps({
  result: {
    type: Object,
    default: null
  }
})

defineEmits(['close'])

const hasStats = computed(() => {
  return (
    props.result?.data &&
    (props.result.data.inserted > 0 ||
      props.result.data.updated > 0 ||
      props.result.data.deleted > 0)
  )
})

const formatDuration = ms => {
  if (ms < 1000) return `${ms}ms`
  const seconds = (ms / 1000).toFixed(1)
  return `${seconds}s`
}
</script>
